import React from 'react'
import SEOTitle from '@chegg-wt/core/components/SEOTitle'
import MetaDescription from '@chegg-wt/core/components/Head/MetaDescription'
import { useRouter } from 'next/router'
import SourceTypeSelection from '@chegg-wt/core/components/Layouts/SourceTypeSelection'
import { NextPageWithLayout } from '@chegg-wt/core/types/layout'
import { getLvpLayout } from '@chegg-wt/core/components/Layouts/LargeVideoPlayerLayout'
import { NextPageContext } from 'next'
import {
  getActualStyleId,
  getCapitalizedSEONameOfStyle,
  isStyleIdInValid,
} from '@chegg-wt/core/utils/styles'
import SourceTypeSelectionTop from '@chegg-wt/core/components/SourceTypeSelectionTop'
import { Config } from '@chegg-wt/core/config'
import { getUrlStyleNameV2 } from '@chegg-wt/core/api/oneGraph'
import { useOnUnloadTimeOnPage } from '@chegg/time-on-page'
import upgradeCopy from '../copy/upgrade'
import considerCredibility from '../copy/credibility'
import { resources } from '../copy/resources'
import { getStyleDesc } from '../copy/seo-content/seoDescriptions'

interface SourceSelectionPageProps {
  initialUrlStyleName: string
}

const SourceSelectionPage: NextPageWithLayout<SourceSelectionPageProps> = ({
  initialUrlStyleName,
}) => {
  const { style } = useRouter().query as { style: string }
  const newStyleDesc = getStyleDesc(style)
  const formattedStyle = getCapitalizedSEONameOfStyle(style)
  useOnUnloadTimeOnPage()
  // Free IEEE Citation Generator and Format|Citation Machine
  return (
    <>
      <SEOTitle
        title={`Free ${formattedStyle} Citation Generator and Format | Citation Machine`}
      />
      <MetaDescription
        content={
          newStyleDesc === 'Not found'
            ? `Generate ${formattedStyle} citations in seconds. Start citing books, websites, journals, and more with the Citation Machine® ${formattedStyle} Citation Generator.`
            : newStyleDesc
        }
      />
      <SourceTypeSelection
        copy={{
          upgradeCopy,
          considerCredibility,
          resources,
        }}
        styleId={getActualStyleId(style)}
        initialUrlStyleName={initialUrlStyleName}
      />
    </>
  )
}

export const getServerSideProps = async ({ query }: NextPageContext) => {
  const { style } = query as { style: string }
  const [initialUrlStyleName] = await getUrlStyleNameV2(style)
  return {
    props: {
      initialUrlStyleName,
      isDefaultStyle: getActualStyleId(style) === Config.currentStyle,
    },
    notFound: isStyleIdInValid(style),
  }
}

SourceSelectionPage.getPageLayout = (page, ssrProps) =>
  getLvpLayout(page, () => <SourceTypeSelectionTop {...ssrProps} />)

export default SourceSelectionPage
